import React, { Component} from "react";
import Addvendorpayment from './Addvendorpayment';
import { NavLink,Navigate  } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TabContext from '@mui/lab/TabContext';

import Customerrefund from './Customerrefund';
import TabPanel from '@mui/lab/TabPanel';
export default class Paymentexpenses extends Component {
	
	 constructor(props) {
    super(props);
	 this.state = {paytab:'1'}
	 }
	 
	 
	 componentWillMount() {
	document.title = "Isifol - Payment (Outgoing money)";

if(localStorage.getItem("ISIuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
		  
		   
	 this.props.parentdasCallback(
          "Payment (Outgoing money)~"
        );
		
}


handlepaytab= (event, newValue) => {

  
   this.setState({paytab: newValue});
	}
render()
{
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
	}
		return(
		   <React.Fragment>
		
		  
		   <TabContext value={this.state.paytab}> 
	  <Box sx={{ width: '100%',  }}>
      <Tabs value={this.state.paytab} onChange={this.handlepaytab} centered>
        <Tab label="Vendor Payment" value="1"/>

        <Tab label="Customer Refund" value="2"/>
      </Tabs>
    </Box>
	
	  <TabPanel value="1"><Addvendorpayment  /></TabPanel>
	  	  <TabPanel value="2"><Customerrefund  /></TabPanel>
	  
 </TabContext>
		   
		    </React.Fragment>
	 )
		  }
}





	
	 





 



	
	





